import gql from 'graphql-tag';
import { PROJECT_BANK_ATTACHMENT_SELECTION } from './projectBankAttachmentSelection';

/**
 * Data of the block project-bank-capital-assets ("Kapitalerträge", tab Bank): its fields of `bank` and the bank attachments of its types. Read through
 * `Project.blocks.bankCapitalAssets`, which checks the block's read permission.
 */
export const PROJECT_BANK_CAPITAL_ASSETS_FIELDS = gql`
  fragment projectBankCapitalAssetsFields on ProjectBankCapitalAssetsBlock {
    id
    number
    bank {
      declaredAssets
      ${PROJECT_BANK_ATTACHMENT_SELECTION}
    }
  }
`;
